<template>
  <v-toolbar-items>
    <v-btn
      tile
      small
      class="main-menu px-0 mr-3 pb-1"
      text
      :ripple="false"
      v-for="link in nestedNavigationLinks"
      :key="link.title"
      :to="link.to"
      click="emitTypeOfTable(link.attr)"
      :data-test-id="link.meta && link.meta.id"
    >
      {{ link.title }}
    </v-btn>
  </v-toolbar-items>
</template>

<script>
export default {
  data() {
    return {
      nestedNavigationLinks: [
        {
          title: 'For Approval',
          to: '/discovery/approval-dashboard/for-approval',
          meta: {
            id: 'discovery__for-approval-tab'
          }
        },
        {
          title: 'Requested for Edit',
          to: '/discovery/approval-dashboard/edit-requested',
          meta: {
            id: 'discovery__requested-for-edit-tab'
          }
        },
        {
          title: 'Approved',
          to: '/discovery/approval-dashboard/approved',
          meta: {
            id: 'discovery__approved-tab'
          }
        },
        {
          title: 'Rejected',
          to: '/discovery/approval-dashboard/rejected',
          meta: {
            id: 'discovery__rejected-tab'
          }
        }
      ]
    };
  }
};
</script>
